import React from "react";

import { useState, useContext } from "react";
import Label from "../../../atoms/Label/Label";
import Select from "../../../atoms/Select/Select";
import Input from "../../../atoms/Input/Input";
import { FormContext } from "../FormContext";

import "./FormBuilder.scss";

const FormBuilder = ({
  field: { id, name, type, labelText, options, title },
}: any) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [textValue, setTextValue] = useState("");
  const { handleChange } = useContext(FormContext);

  switch (type) {
    case "text":
      return (
        <div>
          <Input
            id={name}
            name={name}
            label={title}
            type={type}
            value={textValue}
            onChange={(event) => {
              setTextValue(event);
              handleChange(id, event, type);
            }}
          />
        </div>
      );
    case "select":
      return (
        <div className="select-container">
          <Select
            id="select-field"
            label={labelText}
            selectedIndex={selectedIndex}
            options={options}
            onChange={(event) => {
              setSelectedIndex(event);
              handleChange(id, event, type);
            }}
          />
        </div>
      );
    case "radio":
      return (
        <div className="radio-container">
          <section className="labels">
            <Label children={labelText} htmlFor={name} />
            {title && <Label children={title} htmlFor={name} />}
          </section>
          <div className="radio-options">
            {options.map((option: any, i: number) => (
              <div key={i}>
                <Input
                  id={`${name}${option.label}`}
                  name={name}
                  type={type}
                  value={option.value}
                  onChange={(event) => handleChange(id, event, type)}
                />
                <label htmlFor={`${name}${option.label}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default FormBuilder;
